<template>
  <!--  -->
  <div class="policy-release">
    <div style='background: #fff;padding: 20px;'>
      <div class="titleMain">
        <span class="titleSpan">诚信信息</span>
        <Icon type="ios-arrow-forward" />
        <span class="titleName">{{corpBaseInfoVO.corpName}}</span>
      </div>
      <div class="title">
        <Icon type="ios-bookmark" style="color: #3284FF;" />企业基本信息
      </div>
      <div class="form">
        <Row>
          <Col span="12">
            <div class="form-item">
              <p class="label">企业名称</p>
              <p class="value" style="font-weight: 600;">{{corpBaseInfoVO.corpName}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label">统一社会信用代码</p>
              <p class="value no-border-right">{{corpBaseInfoVO.corpCode}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label">企业法定代表人</p>
              <p class="value">{{corpBaseInfoVO.legalMan}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label">注册所在地</p>
              <p class="value no-border-right">{{corpBaseInfoVO.registerAddress}}</p>
            </div>
          </Col>
          <Col span="24">
            <div class="form-item">
              <p class="label">项目经营地址</p>
              <p class="value no-border-right">{{corpBaseInfoVO.address}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label">企业成立时间</p>
              <p
                class="value"
              >{{corpBaseInfoVO.corpBirthDate && corpBaseInfoVO.corpBirthDate.split('T')[0]}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label">企业登记注册类型</p>
              <p class="value no-border-right">{{filterCompanyType}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label no-border-bottom">信用评分</p>
              <p class="value no-border-bottom">{{corpBaseInfoVO.creditScore}}</p>
            </div>
          </Col>
          <Col span="12">
            <div class="form-item">
              <p class="label no-border-bottom">评分更新时间</p>
              <p class="value no-border-right no-border-bottom">{{corpBaseInfoVO.updateDate}}</p>
            </div>
          </Col>
        </Row>
      </div>
      <div class="tables" style="margin-top: 20px">
        <Tabs value="name1">
          <TabPane label="优良行为记录" name="name1">
            <Table :columns="corpGoodCreditColumns" border :data="corpGoodCreditList" highlight-row></Table>
          </TabPane>
          <TabPane label="不良行为记录" name="name2">
            <Table :columns="corpBadCreditColumns" border :data="corpBadCreditList" highlight-row></Table>
          </TabPane>
        </Tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCorpCreditByUuid ,getCompanyType } from "@/api/homePage.js";

export default {
  name: "",
  props: {},
  data() {
    return {
      carousel: 0,
      imgList: [],
      uuid: '',
      companyType: [],
      corpBaseInfoVO: {

      },
      corpGoodCreditList: [],
      corpBadCreditList: [],
      corpGoodCreditColumns: [
          {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center',
              fixed: 'left'
          },
          {
              title: '市场主体',
              key: 'dicBazaarCode',
              minWidth: 140,
              align: 'center'
          },{
              title: '企业名称',
              key: 'corpName',
              minWidth: 150,
              align: 'center'
          },
          {
              title: '统一社会信用代码',
              key: 'corpCode',
              width: 190,
              align: 'center'
          },
          {
              title: '良好行为描述',
              key: 'fContent',
              minWidth: 180,
              align: 'center'
          },
          {
              title: '奖励部门',
              key: 'awardDepartment',
              width: 180,
              align: 'center'
          },
          {
              title: '信用分值变化',
              key: 'scoreChange',
              width: 130,
              align: 'center'
          },
          {
              title: '登记部门',
              key: 'createDepName',
              width: 150,
              align: 'center'
          },
          {
              title: '登记人',
              key: 'createUserName',
              width: 120,
              align: 'center'
          },
          {
              title: '登记时间',
              key: 'createDate',
              width: 160,
              align: 'center'
          }
      ],
      corpBadCreditColumns: [
          {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center',
              fixed: 'left'
          },
          {
              title: '诚信主体',
              key: 'dicBazaarCode',
              width: 140,
              align: 'center'
          },{
              title: '企业名称',
              key: 'corpName',
              width: 190,
              align: 'center'
          },
          {
              title: '统一社会信用代码',
              key: 'corpCode',
              width: 190,
              align: 'center'
          },
          {
              title: '不良行为类别',
              key: 'fCreditType',
              width: 140,
              align: 'center'
          },
          {
              title: '不良行为描述',
              key: 'fContent',
              minWidth: 140,
              align: 'center'
          },
          {
              title: '处罚部门',
              key: 'departName',
              width: 140,
              align: 'center'
          },
          {
              title: '处理结果',
              key: 'result',
              minWidth: 140,
              align: 'center'
          },
          {
              title: '分值变化',
              key: 'scoreChange',
              width: 130,
              align: 'center'
          },
          {
              title: '公开期限',
              key: 'publicDate',
              width: 130,
              align: 'center'
          },
          {
              title: '登记部门',
              key: 'createDepName',
              width: 150,
              align: 'center'
          },
          {
              title: '登记人',
              key: 'createUserName',
              width: 120,
              align: 'center'
          },
          {
              title: '登记时间',
              key: 'createDate',
              width: 160,
              align: 'center'
          }
      ]
    };
  },
  components: {},
  computed: Object.assign({
      filterCompanyType() {
        if(this.companyType.length > 0 && this.corpBaseInfoVO.economicNum != null) {
            return this.companyType.find(it => it.typeCode == this.corpBaseInfoVO.economicNum).typeInfo
        }
        return ''
      }
  }, mapGetters([
        '_dict'
    ])
  ),
  watch: {},
  created() {
    this.uuid = this.$route.query.uuid;
    this.getTableData();
  },
  mounted() {},
  methods: {
    handleSearch() {
      this.getTableData();
    },
    handleInitParam() {

    },
    // 获取表格数据
    getTableData() {
      getCorpCreditByUuid({uuid: this.uuid})
        .then(res => {
          if (res.status != 200) return
          const { corpBaseInfoVO = {}, corpGoodCreditList = [], corpBadCreditList = [] } = res.data
            corpGoodCreditList && corpGoodCreditList.map((item) => {
                this._dict.market_type.map((it) => {
                    if (it.dicCode == item.dicBazaarCode) {
                        item.dicBazaarCode = it.dicName
                    }
                })
            })
            corpBadCreditList && corpBadCreditList.map((item) => {
                this._dict.market_type.map((it) => {
                    if (it.dicCode == item.dicBazaarCode) {
                        item.dicBazaarCode = it.dicName
                    }
                })
            })
            this.corpBaseInfoVO = corpBaseInfoVO || {}
            this.corpGoodCreditList = corpGoodCreditList || []
            this.corpBadCreditList = corpBadCreditList || []
            }).catch(() => {
            this.$Message.error('获取详情失败！')
        })
        getCompanyType().then((res) => {
            // console.log(res, 'getCompanyType')
            this.companyType = res.data || []
        })
    },
    /*处理操作*/
    handleDeal(name, uuid) {
      this.$router.push({
        name: name,
        query: {
          uuid
        }
      });
    },
    handleTypeChange(val) {}
  }
};
</script>

<style lang="less" scoped>
.policy-release {
  background: #f5f5f5;
  height: 100%;
  padding: 20px 8%;
  .cover-table {
    background: #fff;
    border-radius: 4px;
    padding: 15px;
  }
  .titleMain {
      height: 40px;
      line-height: 40px;
      .titleSpan {
          font-size: 12px;
          color: gray;
      }
      .titleName {
          font-size: 12px;
      }
  }
  .title {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .form {
    margin: 12px 0px 0;
    border: 1px solid #E9E9E9;
    .form-item {
      display: flex;
      flex-direction: row;
      height: 50px;
      .label{
        width: 200px;
        padding: 12px 16px;
        // background: #F9F9F9;
        font-weight: 600;
        font-size: 12px;
        text-align: right;
        line-height: 26px;
        border-right: 1px solid #E9E9E9;
        border-bottom: 1px solid #E9E9E9;
      }
      .value{
        flex: 1;
        padding: 12px 16px;
        font-size: 12px;
        line-height: 26px;
        border-right: 1px solid #E9E9E9;
        border-bottom: 1px solid #E9E9E9;
        background: #F9F9F9;
        background: #fff;
      }
      .value.no-border-right {
        border-right: none;
      }
      .label.no-border-bottom, .value.no-border-bottom {
        border-bottom: none;
      }
    }
  }
}
</style>
